// form.component.ts
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-form',
  template: `
            <div class="row">
              <ng-container *ngFor="let field of formFields">
                <div class="col-2">
                  <app-form-field 
                              [field]="field"
                              [listDR]="lists.listDR"
                              [listStructure]="lists.listStructure"
                              [(ngModel)]="form[field.name]"
                              [ngModelOptions]="{standalone: true}"
                              (onChangeItem)="onChangeItem.emit($event)"
                              (onClearItem)="onClearItem.emit(field.name)">
                            </app-form-field>
                </div>
              </ng-container>
              
              <div class="col-md-2">
                <br />
                <button class="btn btn-dark mr-2" (click)="filtr.emit()" ><!-- [disabled]="!form.direction" -->
                  <i class="ti-filter"></i>
                </button>
                <button class="btn btn-secondary" (click)="clearValue.emit()">
                  <i class="ti-reload"></i>
                </button>
              </div>
            </div>
  `
})
export class FormComponent {
  @Input() form: any;
  @Input() lists: any;
  @Input() vueListAgent: boolean;
  @Output() onChangeItem = new EventEmitter<any>();
  @Output() onClearItem = new EventEmitter<string>();
  @Output() filtr = new EventEmitter<void>();
  @Output() clearValue = new EventEmitter<void>();

  formFields = [
    { name: 'direction', label: 'Direction', required: true },
    { name: 'structure', label: 'Structure', required: false },
    { name: 'matricule', label: 'Matricule', required: false },
    { name: 'nom_prenoms', label: 'Nom ou Prénoms', required: false },
  ];


}
